var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoteral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L4.04 8.98C4.06 10.57 5.29 11.85 6.83 11.9H16.14L6.82 11.92C4.08 12.08 4.04 15.5 4.04 15.5C4.04 17.32 5.48 18.83 7.1 18.84L14.93 18.91C15.74 19 16.08 19.48 16.08 20.42V23.65",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97078 6V6.93C9.02078 8.01 9.57078 8.01 9.98078 8.03L17.5808 8.09C19.3308 8.17 20.7108 9.64 20.7208 11.44C20.7208 13.38 20.0108 14.84 18.4908 15.33L8.05078 15.41C8.05078 15.41 15.0608 15.36 17.4808 15.41C19.3308 15.45 20.6408 17.57 20.7508 19.33V23.65",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoteral);
export default __webpack_public_path__ + "static/media/Coloteral.e0d4cb0fcf6db96be4730fb403e4356d.svg";
export { ForwardRef as ReactComponent };